import initSearchbox from './utils/initSearchbox';

function initSearchboxWithInitialState() {
  initSearchbox(window.__INITIAL_STATE__);
}

function startStabSearchbox() {
  if (document.readyState !== 'loading') {
    initSearchboxWithInitialState();
  } else {
    document.addEventListener('DOMContentLoaded', initSearchboxWithInitialState);
  }
}

startStabSearchbox();



// WEBPACK FOOTER //
// ./src/universal/indexStabSb.js